import React from "react";
import { Card } from "react-bootstrap";

const MainCard = ({ children }) => {
  return (
    <Card className="shadow-lg border-0 rounded-4 overflow-hidden bg-white p-3 h-100">
      {children}
    </Card>
  );
};

export default MainCard;
